import * as actionTypes from '../actions/actionTypes'
import moment from 'moment'

const initialState = {
  assignmentInfo: null,
  assignmentItems: [],
  assignmentItemIds: [],
  deployItemIds: [],
  // assignmentData: null,
  structures: [],
  filter: null,
  appraisalType: null,
  assignmentTargetIds: [],
  action: 'general',
  frequencies: [],
  // responsibles: [],
  forms: [],
  criteria: [],
  loadingQueue: [],
  assignSuccessList: [],
  competencyScores: []
}

const setAssignFilter = (state, { filterOptions }) => {
  return {
    ...state,
    filter: filterOptions
  }
}

const setAssignTarget = (state, { targetIds, appraisalType }) => {
  return {
    ...state,
    assignmentTargetIds: targetIds,
    appraisalType: appraisalType
  }
}

const setAssignmentAction = (state, { action }) => {
  return {
    ...state,
    action
  }
}

const setAssignmentItems = (state, { selectedItemIds }) => {
  // const updatedAssignmentItems = state.structures.reduce((selectedStructures, structure) => {
  //   // Find draft structure (Case edit)
  //   const draftStructure = state.assignmentItems.find(struct => {
  //     return +struct.structure_id === +structure.structure_id
  //   })

  //   // Spread out the structure properties
  //   const { structure_id, structure_name, structure_type, items, ...rest } = structure

  //   // Apply structure ID and Name to each items (to display as table)
  //   const selectedStructureItems = items
  //     // Filter out unselected items
  //     .filter(item => selectedItemIds.includes(+item.item_id))
  //     .map(item => {
  //       // In case we have drafted data, we will keep all thier changes.
  //       // So we have to find draft item and add all attributes to item
  //       if (draftStructure) {
  //         const draftItem = draftStructure.result_item.find(
  //           draftItem => +draftItem.item_id === +item.item_id
  //         )

  //         if (draftItem) {
  //           return {
  //             ...item,
  //             ...draftItem,
  //             structure_id,
  //             structure_name,
  //             structure_type
  //           }
  //         }
  //       }

  //       // If no draft data just apply structure ID and Name to each item
  //       return {
  //         ...item,
  //         structure_id,
  //         structure_name,
  //         structure_type
  //       }
  //     })

  //   // Check if any items of current structure have been selected,
  //   // If selected, add structure to assignment data, else skip it
  //   if (selectedStructureItems.length > 0) {
  //     // If draft structure exists, use draft structure data instead.
  //     if (draftStructure) {
  //       return [
  //         ...selectedStructures,
  //         { ...rest, ...draftStructure, result_item: selectedStructureItems }
  //       ]
  //     }
  //     // Else, just add to assignment data
  //     return [
  //       ...selectedStructures,
  //       {
  //         ...rest,
  //         structure_id,
  //         structure_name,
  //         structure_type,
  //         result_item: selectedStructureItems
  //       }
  //     ]
  //   }
  //   return selectedStructures
  // }, [])

  return {
    ...state,
    // assignmentItems: [...updatedAssignmentItems],
    assignmentItemIds: selectedItemIds
  }
}

const saveAssignmentDraft = (state, { data, itemIds }) => {
  return { ...state, assignmentItems: data, assignmentItemIds: itemIds }
}

const clearAssignmentItems = state => {
  return {
    ...state,
    assignmentItems: [],
    assignmentItemIds: [],
    assignmentInfo: null,
    // assignmentData: {},
    assignSuccessList: [],
    assignmentTargetIds: []
  }
}

const setAssignmentData = (state, { data }) => {
  return { ...state, assignmentInfo: { ...state.assignmentInfo, ...data } }
}

const saveAssignmentDataStart = state => {
  return {
    ...state,
    loadingQueue: [...state.loadingQueue, 'saveAssignment']
  }
}

const saveAssignmentDataSuccess = (state, { structureId }) => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item !== 'saveAssignment'),
    assignSuccessList: [...state.assignSuccessList, structureId]
  }
}

const saveAssignmentDataFailed = state => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item !== 'saveAssignment'),
    assignSuccess: false
  }
}

const updateAssignmentDataStart = state => {
  return {
    ...state,
    loadingQueue: [...state.loadingQueue, 'saveAssignment']
  }
}

const updateAssignmentDataSuccess = (state, { structureId }) => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item !== 'saveAssignment'),
    assignSuccessList: [...state.assignSuccessList, structureId]
  }
}

const updateAssignmentDataFailed = state => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item !== 'saveAssignment'),
    assignSuccess: false
  }
}

const fetchAssignmentByIdStart = state => {
  return {
    ...state,
    loadingQueue: [...state.loadingQueue, 'assignmentById']
  }
}

const fetchAssignmentByIdSuccess = (state, { assignmentInfo, assignmentItems }) => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item !== 'assignmentById'),
    assignmentInfo,
    assignmentItems: assignmentItems.map(st => ({ ...st, stage_id: st.stage[0]?.stage_id })),
    // assignmentData,
    appraisalType: assignmentInfo?.appraisal_type,
    assignSuccess: false
  }
}

const fetchAssignmentByIdFailed = state => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item !== 'assignmentById')
  }
}

const fetchFormOptionsForAppraisalStart = state => {
  return {
    ...state,
    loadingQueue: [...state.loadingQueue, 'forms']
  }
}

const fetchFormOptionsForAppraisalSuccess = (state, { data }) => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item !== 'forms'),
    forms: data
  }
}

const fetchFormOptionsForAppraisalFailed = state => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item !== 'forms')
  }
}

const fetchResponsibleOptionsForAppraisalStart = state => {
  return {
    ...state,
    loadingQueue: [...state.loadingQueue, 'employee']
  }
}

const fetchResponsibleOptionsForAppraisalSuccess = (state, { data, structureId, itemData }) => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item !== 'employee'),
    assignmentItems: state.assignmentItems.map(st => {
      if (+st.structure_id === +structureId) {
        return {
          ...st,
          result_item: st.result_item.map(item => {
            if (+item.item_id === +itemData.item_id) {
              return {
                ...itemData,
                responsible_id: null,
                responsible_list: data
              }
            }
            return item
          })
        }
      }
      return st
    })
  }
}

const fetchResponsibleOptionsForAppraisalFailed = state => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item !== 'employee')
  }
}

const fetchCriteriaOptionsStart = state => {
  return {
    ...state,
    loadingQueue: [...state.loadingQueue, 'criteria']
  }
}

const fetchCriteriaOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item !== 'criteria'),
    criteria: data
  }
}

const fetchCriteriaOptionsFailed = state => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item !== 'criteria')
  }
}

const fetchFrequencyTypeOptionsStart = state => {
  return {
    ...state,
    loadingQueue: [...state.loadingQueue, 'frequency_type']
  }
}

const fetchFrequencyTypeOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item !== 'frequency_type'),
    frequencies: data
  }
}

const fetchFrequencyTypeOptionsFailed = state => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item !== 'frequency_type')
  }
}

const fetchAppraisalStructureStart = state => {
  return {
    ...state,
    loadingQueue: [...state.loadingQueue, 'structures']
  }
}

const fetchAppraisalStructureSuccess = (state, { structures, deployItemIds, ...rest }) => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item === 'structures'),
    structures,
    deployItemIds
  }
}

const fetchAppraisalStructureFailed = state => {
  return {
    ...state,
    loadingQueue: state.loadingQueue.filter(item => item === 'structures')
  }
}

const fetchAssignmentDataTemplateStart = state => {
  return {
    ...state
  }
}

const fetchAssignmentDataTemplateSuccess = (state, { data }) => {
  let itemIds = []
  const draftBase = state.assignmentItems
  const buildedData = data.map(struct => {
    const oldStructExists = draftBase.find(st => {
      return +st.structure_id === +struct.structure_id
    })

    const assignedDate = struct.assigned_date ?? moment().format('YYYY-MM-DD')

    const structureCode = struct.structure_type.value_list_code
    let updatedStruct = {
      ...struct,
      assigned_date: assignedDate,
      stage_id: struct.stage[0]?.stage_id || null,
      result_item:
        structureCode === 'STT05'
          ? struct.result_item
          : struct.result_item.map(item => {
              if (item.adopt_allowed && item.adopt_item) {
                return {
                  ...item,
                  ...item.adopt_item,
                  is_deploy: item.is_deploy,
                  is_adopt: true,
                  result_item_id: item.result_item_id
                }
              }
              return item
            })
    }
    if (oldStructExists) {
      let templateWithDraftedData = []
      if (structureCode !== 'STT05') {
        templateWithDraftedData = struct.result_item?.map(item => {
          const draftedItem = oldStructExists.result_item?.find(
            drafted => +drafted.item_id === +item.item_id
          )
          if (draftedItem) {
            return {
              ...item,
              ...draftedItem,
              result_kpi: (draftedItem.result_kpi || [])?.map(result => {
                const draftedKpi = draftedItem.result_kpi?.find(
                  kpi => result.frequency_no === kpi.frequency_no
                )
                if (draftedKpi) {
                  return {
                    ...result,
                    ...draftedKpi,
                    result_kpi_id: result.result_kpi_id
                  }
                }
                return result
              })
            }
          }
          return item
        })
      } else {
        templateWithDraftedData = Object.entries(struct.result_item)?.reduce((builded, group) => {
          const [groupCode, groupAttrs] = group
          const groupItems = groupAttrs.items
          const oldWeight =
            oldStructExists.result_item[groupCode]?.weight_percent || groupAttrs.weight_percent
          const appliedItems = groupItems.map(item => {
            const draftedItem = oldStructExists.result_item[groupCode]?.items?.find(
              drafted => +drafted.item_id === +item.item_id
            )
            if (draftedItem) {
              return {
                ...item,
                ...draftedItem
              }
            }
            return item
          })
          return {
            ...builded,
            [groupCode]: { ...groupAttrs, weight_percent: oldWeight, items: appliedItems }
          }
        }, {})
      }
      updatedStruct = {
        ...struct,
        ...oldStructExists,
        result_item: templateWithDraftedData
      }
      // }

      if (structureCode !== 'STT05') {
        const structureItems = struct.result_item.map(item => +item.item_id)
        itemIds = [...itemIds, structureItems]
      } else {
        const structureItems = Object.values(struct.result_item).flatMap(group =>
          group.items.map(item => +item.item_id)
        )
        itemIds = [...itemIds, structureItems]
      }
      return updatedStruct
    }
    return updatedStruct
  })
  return {
    ...state,
    assignmentItems: buildedData,
    assignmentItemIds: itemIds
  }
}

const fetchAssignmentDataTemplateFailed = state => {
  return {
    ...state
  }
}

export default (state = initialState, { type, ...payload }) => {
  switch (type) {
    case actionTypes.ASSIGNMENT_SET_ASSIGN_FILTER:
      return setAssignFilter(state, payload)
    case actionTypes.ASSIGNMENT_SET_ASSIGN_TARGET:
      return setAssignTarget(state, payload)
    case actionTypes.ASSIGNMENT_SET_ASSIGN_ACTION:
      return setAssignmentAction(state, payload)
    case actionTypes.ASSIGNMENT_SET_ASSIGN_ITEMS:
      return setAssignmentItems(state, payload)
    case actionTypes.ASSIGNMENT_SAVE_DRAFT:
      return saveAssignmentDraft(state, payload)
    case actionTypes.ASSIGNMENT_SET_ASSIGN_DATA:
      return setAssignmentData(state, payload)
    case actionTypes.ASSIGNMENT_CLEAR_ASSIGN_ITEMS:
      return clearAssignmentItems(state, payload)

    case actionTypes.ASSIGNMENT_SAVE_ASSIGN_START:
      return saveAssignmentDataStart(state, payload)
    case actionTypes.ASSIGNMENT_SAVE_ASSIGN_SUCCESS:
      return saveAssignmentDataSuccess(state, payload)
    case actionTypes.ASSIGNMENT_SAVE_ASSIGN_FAILED:
      return saveAssignmentDataFailed(state, payload)

    case actionTypes.ASSIGNMENT_UPDATE_ASSIGN_START:
      return updateAssignmentDataStart(state, payload)
    case actionTypes.ASSIGNMENT_UPDATE_ASSIGN_SUCCESS:
      return updateAssignmentDataSuccess(state, payload)
    case actionTypes.ASSIGNMENT_UPDATE_ASSIGN_FAILED:
      return updateAssignmentDataFailed(state, payload)

    case actionTypes.ASSIGNMENT_FETCH_BY_ID_START:
      return fetchAssignmentByIdStart(state, payload)
    case actionTypes.ASSIGNMENT_FETCH_BY_ID_SUCCESS:
      return fetchAssignmentByIdSuccess(state, payload)
    case actionTypes.ASSIGNMENT_FETCH_BY_ID_FAILED:
      return fetchAssignmentByIdFailed(state, payload)

    case actionTypes.FETCH_ASSIGNMENT_DATA_TEMPLATE_START:
      return fetchAssignmentDataTemplateStart(state, payload)
    case actionTypes.FETCH_ASSIGNMENT_DATA_TEMPLATE_SUCCESS:
      return fetchAssignmentDataTemplateSuccess(state, payload)
    case actionTypes.FETCH_ASSIGNMENT_DATA_TEMPLATE_FAILED:
      return fetchAssignmentDataTemplateFailed(state, payload)

    case actionTypes.FETCH_APPRAISAL_STRUCTURES_START:
      return fetchAppraisalStructureStart(state, payload)
    case actionTypes.FETCH_APPRAISAL_STRUCTURES_SUCCESS:
      return fetchAppraisalStructureSuccess(state, payload)
    case actionTypes.FETCH_APPRAISAL_STRUCTURES_FAILED:
      return fetchAppraisalStructureFailed(state, payload)

    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_START:
      return fetchFormOptionsForAppraisalStart(state, payload)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchFormOptionsForAppraisalSuccess(state, payload)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchFormOptionsForAppraisalFailed(state, payload)

    case actionTypes.FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_START:
      return fetchResponsibleOptionsForAppraisalStart(state, payload)
    case actionTypes.FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchResponsibleOptionsForAppraisalSuccess(state, payload)
    case actionTypes.FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchResponsibleOptionsForAppraisalFailed(state, payload)

    case actionTypes.FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_START:
      return fetchCriteriaOptionsStart(state, payload)
    case actionTypes.FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchCriteriaOptionsSuccess(state, payload)
    case actionTypes.FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchCriteriaOptionsFailed(state, payload)

    case actionTypes.FETCH_FREQUENCY_TYPE_OPTIONS_START:
      return fetchFrequencyTypeOptionsStart(state, payload)
    case actionTypes.FETCH_FREQUENCY_TYPE_OPTIONS_SUCCESS:
      return fetchFrequencyTypeOptionsSuccess(state, payload)
    case actionTypes.FETCH_FREQUENCY_TYPE_OPTIONS_FAILED:
      return fetchFrequencyTypeOptionsFailed(state, payload)

    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }

    default:
      return state
  }
}
